module.exports = __webpack_public_path__ + "img/minus.b46b374d.svg";